<template>
  <v-card
    class="ma-0"
    width="100%"
    style="height: auto"
    elevation="2"
  >
  <v-app-bar
      flat
      class="my-0 mb-6 py-1 px-2"
      dense
      height="30"
    >
      <v-toolbar-title class="mt-4 me-4">{{ $t('accountingGroup') }}</v-toolbar-title>
      <div
        v-if="!isMobile && !isTablet"
        style="width: 230px;"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </div>
      <v-spacer />
      <v-btn
        v-if="selected.length > 0 && !isMobile"
        outlined
        @click="deletDialog = true"
        class="mt-4 ms-2"
        color="pink"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('remove') }}
        </p>
        <v-icon>
          mdi-trash-can-outline
        </v-icon>
      </v-btn>
      <v-menu
        offset-y
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            outlined
            class="mt-4 px-1 ms-2"
            color="grey darken-2"
            height="32"
            v-bind="attrs"
            v-on="on"
            style="min-width: 35px !important;padding: 0 !important;"
          >
            <!-- <p class="mb-0 me-2">
              {{$t('more')}}
            </p> -->
            <v-icon>
              mdi-dots-vertical
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <log
            v-if="$store.state.permissions && $store.state.permissions.includes('logList')"
            ref="logRef"
            :type-prop="type"
            :listProp="true"
            mode-prop="button"
          />
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="getItems"
          >
            <v-list-item-icon>
              <v-icon>mdi-refresh</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('refresh')" />
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @getAllRows="getAllRows"
          >
          <export-excel
            ref="refExcel"
            :data="excelItems"
            worksheet="abriron.com"
            name="data.xls"
            type="xls"
            class="float-left d-flex"
            :title="$store.state.abrName"
            :total-prop="pageCount"
            :page-prop="excelPage"
            @getAllRows="getAllRows"
          >
            <v-list-item-icon>
              <v-icon>mdi-file-excel-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('excel')" />
          </export-excel>
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="printDialog = true"
          >
            <v-list-item-icon>
              <v-icon>mdi-printer-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('print')" />
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="newGroup"
          >
            <v-list-item-icon>
              <v-icon>mdi-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('newGroup')" />
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="getItems"
        class="mt-4 px-1 ms-2"
        color="grey darken-2"
        height="32"
        @shortkey="getItems"
        v-shortkey="['f5']"
        style="min-width: 35px !important;padding: 0 !important;"
      >
        <!-- <p class="mb-0 me-2">
          {{$t('refresh')}}
        </p> -->
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>
      <export-excel
        v-if="!isMobile && !isTablet"
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        class="float-left"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <v-btn
          outlined
          class="mt-4 ms-2"
          color="grey darken-2 "
          height="32"
        >
          <p class="font-weight-thin mb-0 me-2">
            {{ $t('excel') }}
          </p>
          <v-icon>
            mdi-file-excel-outline
          </v-icon>
        </v-btn>
      </export-excel>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="printDialog = true"
        class="mt-4  ms-2"
        color="grey darken-2"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('print') }}
        </p>
        <v-icon>
          mdi-printer-outline
        </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="newGroup"
        class="mt-4 ms-2"
        color="primary"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('newGroup') }}
        </p>
        <v-icon>
          mdi-plus
        </v-icon>
      </v-btn>
    </v-app-bar>
    <v-row
      v-if="isMobile || isTablet"
      class="mx-0"
    >
      <v-col
        class="mb-4 px-2"
        cols="12"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-col
      id="print"
      cols="12"
      class="px-2 pt-0"
    >
      <v-data-table
        v-if="headers"
        v-model="selected"
        :height="(isMobile || isTablet || mobileShow ? 323 : tableHeight)"
        fixed-header
        :headers="headers"
        :items="items"
        :page.sync="page"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        class="mb-2 td-hide-border"
        style="border: 1px solid #e3e3e3;border-radius: 6px;"
        :footer-props="{
          showFirstLastPage: (!mobileShow ? true : false),
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus'
        }"
      >
        <template v-slot:item.actions="{ item }">
          <v-menu
            offset-y
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="primary"
                v-bind="attrs"
                icon
                v-on="on"
              >
                <v-icon
                  medium
                >
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item
                link
                @click="editGroup(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                link
                @click="groupChild(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-file-tree-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('totalAccounts')" />
              </v-list-item>
              <log
                :title-prop="$t('history')"
                icon-prop="mdi-history"
                :listProp="true"
                :type-prop="typeForm"
                :refIdProp="item.id"
                mode-prop="button"
              />
              <v-list-item
                linkgi
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink">
                    mdi-trash-can-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.row="{ item }">
          {{ parseInt(items.indexOf(item))+ parseInt(from) }}
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-if="item.user"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                {{ item.user.firstname }}  {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.balance_type="{ item }">
          {{ $t(item.balance_type) }}
        </template>
        <template v-slot:item.type="{ item }">
          <div class="pt-1">
            {{ $t(item.type) }}
          </div>
        </template>
        <template v-slot:item.name="{ item }">
          <a
            @click="editGroup(item)"
          >
            {{ item.name }}
          </a>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                color="orange"
                icon
                x-small
                v-on="on"
                @click="groupChild(item)"
              >
                <v-icon>mdi-file-tree-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('totalAccounts') }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.number="{ item }">
          <a
            @click="editGroup(item)"
          >
            {{ item.number }}
          </a>
        </template>
        <template v-slot:item.tags="{ item }">
          <div class="pt-1">
            <v-chip
              v-for="(tag, index) in item.tags"
              :key="index"
              :color="tag.color"
              label
              small
              style="margin-left: 1px;margin-right:1px"
              class="px-1 mb-1"
              @click="edit(item)"
            >
              <span class="px-1 white--text">
                {{ tag.text }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.content="{ item }">
          {{ item.content ? item.content : 'ندارد' }}
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:footer.prepend>
          <v-col
            v-show="!isMobile"
            cols="1"
            class="pa-0"
            style="margin-top: -10px"
          >
            <v-text-field
              v-model.number="page"
              :label="$t('goToPage')"
              min="1"
              :max="pageCount"
              type="number"
              outlined
              height="32"
              hide-details
              hide-spin-buttons
              dense
              :suffix="'  /  ' + pageCount"
            />
          </v-col>
        </template>
      </v-data-table>
    </v-col>
    <v-row />
    <!--    group dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="groupDialog"
      width="100%"
      max-width="450px"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="groupDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('group') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <group
            :item="groupItem"
            @close="closeDialog"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <!--    filter dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="filter"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="filter = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('filter') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="type"
              :label="$t('natureAccount')"
              :items="typeItems"
              height="30"
              dense
              outlined
              multiple
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <status
              v-model="sellStatus"
              :hideconfig="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <tag
              v-model="tag"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="branch"
              title="branch"
              type="branch"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <template>
              <v-text-field
                id="fromId"
                v-model="fromDate"
                :label="$t('from') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="fromDate"
                element="fromId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <template>
              <v-text-field
                id="toId"
                v-model="toDate"
                :label="$t('until') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="toDate"
                element="toId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="fromDate"
                auto-submit
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="fromNumber"
              :label="$t('from') + ' ' + $t('number')"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="toNumber"
              :label="$t('until') + ' ' + $t('number')"
              outlined
              dense
              clearable
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                class=" mx-0"
                color="primary"
                @click="getItems"
              >
                {{ $t('filter') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    tasl dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <!--    delete dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    print dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="40%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col class="text-right">
            <v-radio-group v-model="printType">
              <template v-slot:label>
                <div class="text-right">
                  {{ $t('chooseTemplate') }}
                </div>
              </template>
              <v-radio value="document">
                <template v-slot:label>
                  <div>{{ $t('totalGivenDetails') }}</div>
                </template>
              </v-radio>
              <v-radio value="document1">
                <template v-slot:label>
                  <div>{{ $t('totalGiven') }}</div>
                </template>
              </v-radio>
              <v-radio value="document2">
                <template v-slot:label>
                  <div>{{ $t('givenDetails') }}</div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-btn
            color="primary"
            :loading="loading"
            @click="openPrint"
          >
            {{ $t('print') }}
          </v-btn>
          <v-spacer />
          <v-btn
            color="grey"
            @click="printDialog = !printDialog"
          >
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    upload dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="uploadDialog"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="uploadDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col
          class="mt-0 pt-0 pr-7"
        >
          <upload
            type-prop="accountingDocument"
            :get-item="uploadDialog"
            @close="uploadDialog=false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-component
      :dialog-prop="innerComponent"
      :data-prop="dialogData"
      @close="innerComponent = false"
    />
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'blue')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  import Task from '../task/task'
  import General from '../../../../Mixins/general'
  import Upload from '../../components/general/upload/upload'
  import Group from './group'
  export default {
    name: 'AccountingGroupList',
    components: {
      Tag: () => import('../../components/general/Tag/tag'),
      Status: () => import('../../components/general/Status/status'),
      dialogComponent: () => import('../../components/general/dialog/index'),
      Group,
      Upload,
      Task,
    },
    mixins: [General],
    props: ['input', 'refId', 'mobileShow'],
    data: () => ({
      excelItems: [],
      selected: [],
      pageCount: 1,
      page: 1,
      groupDialog: false,
      printDialog: false,
      printItems: [],
      printType: 'document2',
      deletDialog: false,
      fromNumber: null,
      toNumber: null,
      fromDate: null,
      toDate: null,
      snakbarColor: null,
      uploadDialog: null,
      dialogData: null,
      filter: false,
      model: null,
      from: 1,
      taskDialog: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      taskId: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      type: null,
      headers: null,
      groupItem: null,
      typeItems: null,
      search: null,
      typeForm: null
    }),
    computed: {
      showSelect () {
        if(!this.isMobile) {
          return true
        } else {
          return false
        }
      },
    },
    watch: {
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        this.model = this.selected[0].text
        this.temp = this.selected[0].text
        this.dialog = false
      },
      search () {
        var app = this
        app.page = 1
        app.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
    },
    activated () {
    // this.getItems()
    },
    beforeMount () {
      if (this.$route.name == 'accountingGroup') {
        this.typeForm = 'accountingGroup'
      }
      this.typeItems = [
        {
          value: 'initial',
          text: this.$t('initial'),
        },
        {
          value: 'general',
          text: this.$t('general'),
        },
      ]
      this.headers = [
        {
          text: this.$t('actions'),
          align: 'start',
          sortable: false,
          value: 'actions',
          width: 20,
        },
        {
          text: this.$t('row'),
          align: 'start',
          sortable: false,
          value: 'row',
          width: 20,
        },
        {
          text: this.$t('number'),
          sortable: true,
          value: 'number',
          table: 'financial_group_coding.number',
        },
        {
          text: this.$t('name'),
          sortable: true,
          value: 'name',
          table: 'financial_group_coding.name',
        },
        {
          text: this.$t('type'),
          sortable: true,
          value: 'type',
          table: 'financial_group_coding.type',
        },
        {
          text: this.$t('nature'),
          sortable: true,
          value: 'balance_type',
          table: 'financial_group_coding.balance_type',
        },
        {
          text: this.$t('content'),
          sortable: true,
          value: 'content',
          table: 'financial_group_coding.content',
        },
      ]
      if (this.input) {
        this.model = this.input
      }
    },
    mounted () {
      this.getItems()
    },
    methods: {
      closeDialog () {
        this.getItems()
        this.groupDialog = false
      },
      newGroup () {
        this.groupItem = null
        this.groupDialog = true
      },
      editGroup (item) {
        this.groupItem = item
        this.groupDialog = true
      },
      openDialogPrint (id) {
        this.printItems.push(id)
        this.printDialog = true
      },
      groupPrint () {
        var app = this
        this.selected.map(function (value) {
          app.printItems.push(value.id)
        })
        this.printDialog = true
      },
      openPrint () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'accounting', {
          params: {
            print: 'active',
            id: app.printItems,
            type: app.printType,
          },
        })
          .then(res => {
            res = res.data
            app.$router.push({ name: 'reportViewer', params: { dataProp: res, reportProp: app.printType } })
            app.printItems = []
          // var routeData = app.$router.resolve({ name: 'reportViewer', params: { dataProp: res } })
          // window.open(routeData.href, '_blank')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      openComponent (component, id) {
        this.dialogData = {
          name: component,
          id: id,
        }
        this.innerComponent = true
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      copy (item) {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'accounting/' + item.id + '/edit', {
          params: {
            id: item.id,
          },
        })
          .then(res => {
            res = res.data
            app.$router.push({ name: 'accounting', params: { itemsProp: res.article } })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      groupChild (item) {
        this.$router.push({ name: 'accountingGroupChild', params: { id: item.id, tabName: item.name } })
      },
      openUploadDialog (item) {
        this.uploadDialog = true
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'accounting', {
          params: {
            groupList: 'active',
            search: app.search,
            page: app.options.page,
            refId: app.refId,
            type: app.type,
            branch: app.branch,
            fromNumber: app.fromNumber,
            toNumber: app.toNumber,
            fromDate: app.fromDate,
            toDate: app.toDate,
            sortBy: app.sortBy,
            options: app.options,
            tag: app.tag,
            status: app.sellStatus,
          },
        })
          .then(res => {
            res = res.data
            app.items = res.data
            app.totalItems = res.total
            app.pageCount = res.last_page
            app.from = res.from
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.deletDialog = false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'coding/' + this.deleteItem.id, {
          params: {
            level: 'group',
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      removegroup () {
        var app = this
        app.loading = true
        app.deletDialog = false
        var selected = []
        app.selected.map(function (value, key) {
          selected.push({ id: value.id })
        })
        app.$axios.get(this.$endpoint + 'accounting', {
          params: {
            deleteItems: selected,
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      creatExcelData (data, type = 'page') {
        var app = this
        if (type === 'page') {
          app.excelItems = []
        }
        data.map(function (d) {
          app.excelItems.push({
            number: d.number,
            name: d.name,
            type: app.$t(d.type),
            nature: app.$t(d.balance_type),
            content: d.content,
          })
        })
      },
    },
  }
</script>

<style scoped>
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 32px !important;
}
</style>
